import React, { useState, useEffect } from 'react';

// Import Images
// Construction
import const1 from '../assets/Components/Construction/1aa.webp';
import const2 from '../assets/Components/Construction/2a.webp';

// Exterior
import ext1 from '../assets/Components/Exterior/20X56-Picture2.jpg.jpeg';
import ext2 from '../assets/Components/Exterior/Eid Street-Picture2.jpg.jpeg';
import ext3 from '../assets/Components/Exterior/Elevation-08.jpg.jpeg';
import ext4 from '../assets/Components/Exterior/House_Project-Elevation-01.jpg.jpeg';
import ext5 from '../assets/Components/Exterior/Mansoor_Onion_Plan_Picture2.jpg.jpeg';
import ext6 from '../assets/Components/Exterior/Naafi_Building_Picture1.jpg.jpeg';
import ext7 from '../assets/Components/Exterior/Rafiq_32X27-Picture3.jpeg';

// Interior
import int1 from '../assets/Components/Interior/1aaa.webp';
import int2 from '../assets/Components/Interior/2aaaaaaa.webp';

// Planning
import plan1 from '../assets/Components/Planning/1aaaa.webp';

const Components = () => {
    const [activeFilter, setActiveFilter] = useState('All');
    const [selectedImage, setSelectedImage] = useState(null);

    // Lock body scroll and hide navbar when modal is open
    useEffect(() => {
        if (selectedImage) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('modal-open');
        } else {
            document.body.style.overflow = 'unset';
            document.body.classList.remove('modal-open');
        }
        return () => {
            document.body.style.overflow = 'unset';
            document.body.classList.remove('modal-open');
        };
    }, [selectedImage]);

    const allImages = [
        { src: const1, category: 'Construction' },
        { src: const2, category: 'Construction' },
        { src: ext1, category: 'Exterior Design' },
        { src: ext2, category: 'Exterior Design' },
        { src: ext3, category: 'Exterior Design' },
        { src: ext4, category: 'Exterior Design' },
        { src: ext5, category: 'Exterior Design' },
        { src: ext6, category: 'Exterior Design' },
        { src: ext7, category: 'Exterior Design' },
        { src: int1, category: 'Interior Design' },
        { src: int2, category: 'Interior Design' },
        { src: plan1, category: 'Planning' }
    ];

    const filters = ['All', 'Exterior Design', 'Interior Design', 'Construction', 'Planning'];

    const filteredImages = activeFilter === 'All'
        ? allImages
        : allImages.filter(img => img.category === activeFilter);

    return (
        <div id="components" className="architectural-bg" style={{ padding: 'var(--section-padding)' }}>
            <div className="container">
                <div className="row mb-5">
                    <div className="col-lg-12">
                        <h2 className="section-head-main">Our Components</h2>
                    </div>

                    {/* Filters */}
                    <div className="col-12 mt-4">
                        {/* Desktop Filters */}
                        <div className="d-none d-md-flex flex-wrap gap-2">
                            {filters.map(filter => (
                                <button
                                    key={filter}
                                    className={`filter-pill ${activeFilter === filter ? 'active' : ''}`}
                                    onClick={() => setActiveFilter(filter)}
                                >
                                    {filter}
                                </button>
                            ))}
                        </div>

                        {/* Mobile Filters Dropdown */}
                        <div className="d-md-none">
                            <select
                                className="filter-dropdown form-select"
                                value={activeFilter}
                                onChange={(e) => setActiveFilter(e.target.value)}
                            >
                                {filters.map(filter => (
                                    <option key={filter} value={filter}>{filter}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Gallery Grid */}
                <div className="row g-4">
                    {filteredImages.map((item, index) => (
                        <div key={index} className="col-6 col-md-4 col-lg-3 fade-in-grid">
                            <div className="arch-card" onClick={() => setSelectedImage(item.src)}>
                                <img
                                    src={item.src}
                                    alt={item.category}
                                    className="arch-card-img"
                                />
                                <div className="p-3">
                                    <span className="section-index" style={{ fontSize: '0.6rem', marginBottom: '0' }}>
                                        {item.category.toUpperCase()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Gallery Modal */}
            {selectedImage && (
                <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
                    <button className="modal-close-btn" onClick={() => setSelectedImage(null)}>
                        &times;
                    </button>
                    <div className="modal-img-container" onClick={(e) => e.stopPropagation()}>
                        <img src={selectedImage} alt="Gallery view" className="gallery-modal-img" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Components;

